module.exports = __webpack_public_path__ + "img/4_CirMus.4d91585f.png";